module.exports = __webpack_public_path__ + "static/media/logo-black.0749376a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-black.png
// module id = 237
// module chunks = 0